import React, { useEffect, useRef, useState } from 'react';
import { FaPhone, FaEnvelope, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const contactRef = useRef(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = contactRef.current.querySelectorAll('.fade-in, .slide-in-left, .slide-in-right');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const serviceNames = {
      'interiores': 'Design de Interiores',
      'residencial': 'Projeto Residencial',
      'comercial': 'Projeto Comercial',
      'reforma': 'Projeto de Reforma',
      'regularizacao': 'Regularização de Imóveis',
      'aprovacao': 'Aprovação na Prefeitura',
      'outro': 'Outro',
    };

    const whatsappMessage = `Olá! Vim através do site e gostaria de solicitar um orçamento.

*Dados do Cliente:*
• Nome: ${formData.name}
• E-mail: ${formData.email}
• Telefone: ${formData.phone}

*Serviço Desejado:*
${serviceNames[formData.service]}

*Mensagem:*
${formData.message}

Aguardo retorno. Obrigado(a)!`;

    const whatsappNumber = '5519993489551';
    
    const encodedMessage = encodeURIComponent(whatsappMessage);
    
    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    
    window.open(whatsappURL, '_blank');

    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: ''
    });
  };

  const contactInfo = [
    {
      icon: <FaPhone />,
      title: 'Telefone e WhatsApp',
      info: '(19) 99348-9551',
      link: 'tel:+5519993489551'
    },
    {
      icon: <FaEnvelope />,
      title: 'E-mail',
      info: 'arq.biancapaulino@gmail.com',
      link: 'mailto:arq.biancapaulino@gmail.com'
    },
    // {
    //   icon: <FaMapMarkerAlt />,
    //   title: 'Endereço',
    //   info: 'Rio de Janeiro, RJ',
    //   link: '#'
    // },
    // {
    //   icon: <FaClock />,
    //   title: 'Horário',
    //   info: 'Seg - Sex: 9h às 18h',
    //   link: '#'
    // }
  ];

  return (
    <section id="contact" className="contact section" ref={contactRef}>
      <div className="container">
        <div className="section-header fade-in">
          <h2>Entre em Contato</h2>
          <p>Vamos transformar seu sonho em realidade. Conte-nos sobre seu projeto!</p>
        </div>

        <div className="contact-content">
          <div className="contact-info slide-in-left">
            <h3>Fale Conosco</h3>
            <p>
              Estamos prontos para ouvir suas ideias e transformá-las em projetos únicos. 
              Entre em contato e vamos conversar sobre como podemos criar o espaço dos seus sonhos.
            </p>

            <div className="contact-methods">
              {contactInfo.map((item, index) => (
                <a 
                  key={index} 
                  href={item.link} 
                  className="contact-method"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div>{item.icon}</div>
                  <div className="contact-details">
                    <h4>{item.title}</h4>
                    <p>{item.info}</p>
                  </div>
                </a>
              ))}
            </div>

            <div className="social-links">
              <h4>Nos siga no Instagram!</h4>
              <div className="social-icons">
                {/* <a href="#" className="social-icon">
                  <FaFacebook />
                </a> */}
                <a href="https://www.instagram.com/arq.biancapaulino/" className="social-icon">
                  <FaInstagram />
                </a>
                {/* <a href="#" className="social-icon">
                  <FaLinkedin />
                </a> */}
                {/* <a href="#" className="social-icon">
                  <FaPinterest />
                </a> */}
              </div>
            </div>
          </div>

          <div className="contact-form slide-in-right">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Seu nome completo"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    placeholder="Seu e-mail"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Seu telefone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <select
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  required
                >
                  <option value="">Selecione o serviço desejado</option>
                  <option value="interiores">Design de Interiores</option>
                  <option value="residencial">Projeto Residencial</option>
                  <option value="comercial">Projeto Comercial</option>
                  <option value="reforma">Projeto de Reforma</option>
                  <option value="regularizacao">Regularização de Imóveis</option>
                  <option value="aprovacao">Aprovação na Prefeitura</option>
                  <option value="outro">Outro</option>
                </select>
              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Conte-nos sobre seu projeto, suas ideias e expectativas..."
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary btn-full">
                <FaWhatsapp style={{ marginRight: '8px' }} />
                Enviar via WhatsApp
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;